import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import {COMMON_FORM_STAGE, CREATE_FORM_STAGE, identityOptions} from '../../Config/appConfig';
import {Option} from '../../Config/dataModel';

interface IdentityTextFieldProps {
    stage?: string,
    identity: Option,
    identityNo: string,
    checksum: string,
    changeIdentityNo?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    changeChecksum?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

interface IdentityTextFieldState {
    visible: boolean
}

class IdentityTextField extends React.Component <IdentityTextFieldProps, IdentityTextFieldState> {
    public constructor(props: IdentityTextFieldProps) {
        super(props);
        this.state = {
            visible: false
        };
        this.clickVisible = this.clickVisible.bind(this);
	    this.changeInput = this.changeInput.bind(this);
    }

    public clickVisible(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({
            visible: !this.state.visible
        });
    }

    public getIdentityTextField() {
        return (
            <div className="identityTextField">
                <Grid className="identityTextFieldInner" item xs={12}>
                    <input className="cmText"
                           type="text"
                           value={this.props.stage === COMMON_FORM_STAGE.PRINT ? '' :
                               (this.props.identity.value === identityOptions[0].value ?
                               `${this.props.identityNo}(${this.props.checksum})` : this.props.identityNo)}
                           disabled={true}/>
                </Grid>
            </div>
        );
    }

    public changeInput(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const newValue = event.target.value;
        if (newValue.length > 0) { event.target.classList.remove('empty'); }
        else { event.target.classList.add('empty'); }
        return newValue;
    }

    public render() {
        if (this.props.stage !== CREATE_FORM_STAGE.CREATE && this.props.stage !== COMMON_FORM_STAGE.PROCEED) {
            return this.getIdentityTextField();
        }

        let identityNoInputExtraProps = {};
        if (this.props.changeIdentityNo) { identityNoInputExtraProps = {...identityNoInputExtraProps, ...{onChange: (e) => this.props.changeIdentityNo(e)}}; }

        let checksumInputExtraProps = {};
        if (this.props.changeIdentityNo) { checksumInputExtraProps = {...checksumInputExtraProps, ...{onChange: (e) => this.props.changeChecksum(e)}}; }

        const disabled = !(this.props.stage === CREATE_FORM_STAGE.CREATE || this.props.stage === COMMON_FORM_STAGE.PROCEED);
        const isIE = navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/));

        switch (this.props.identity.value) {
            case identityOptions[0].value:
                return (
                    <div className="identityTextField">
                        <Grid className="identityTextFieldInner identityTextFieldLeft" item xs={10}>
                            <Grid className="cmVerCenter" item xs={1}>
                                <button className={`identityTextFieldEye ${this.state.visible ? "visible" : "invisible"}`} onClick={this.clickVisible}><RemoveRedEye/></button>
                            </Grid>
                            <Grid item xs={11}>
                                <input className={`cmText${this.state.visible ? "" : " fakeInputPassword"}`}
                                       type={isIE && !this.state.visible ? "password" : "text"}
                                       value={this.props.identityNo}
                                       disabled={disabled}
                                       {...identityNoInputExtraProps}/>
                            </Grid>
                        </Grid>
                        <Grid className="identityTextFieldRight" item xs={2}>
                            <div className="cmText cmVerCenter parentheses">(</div>
                            <input className={`cmText placeholderIEFix${this.props.checksum.length ? "" : " empty"}${this.state.visible ? "" : " fakeInputPassword"}`}
                                type={isIE && !this.state.visible ? "password" : "text"}
                                value={this.props.checksum}
                                disabled={disabled}
                                onInput={this.changeInput}
                                {...checksumInputExtraProps}/>
                            <div className="cmText cmVerCenter parentheses">)</div>
                        </Grid>
                    </div>
                );
            default:
                return (
                    <div className="identityTextField">
                        <Grid className="identityTextFieldInner" item xs={12}>
                            <Grid className="cmVerCenter" item xs={1}>
                                <button className={`identityTextFieldEye ${this.state.visible ? "visible" : "invisible"}`} onClick={this.clickVisible}><RemoveRedEye/></button>
                            </Grid>
                            <Grid item xs={11}>
                                <input className={`cmText${this.state.visible ? "" : " fakeInputPassword"}`}
                                       type={isIE && !this.state.visible ? "password" : "text"}
                                       value={this.props.identityNo}
                                       disabled={disabled}
                                       {...identityNoInputExtraProps}/>
                            </Grid>
                        </Grid>
                    </div>
                );
        }
    }
}

export default IdentityTextField;



// WEBPACK FOOTER //
// ./src/Components/Custom/IdentityTextField.tsx